import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ProjectPage from './pages/project';
import CoordinatePage from './pages/coordinate';
import WellborePage from './pages/wellbore';
import BoundingboxPage from './pages/boundingbox';
import GeophonePage from './pages/geophone';
import PerforatorPage from './pages/perforator';
import SeismicEventPage from './pages/seismicEvent';
import FormationPage from './pages/formation';
import HistogramPage from './pages/histogram';
import NavigationPage from './pages/navigation';
import ObjectInfoPage from './pages/objectInfo';
import MeasurementPage from './pages/measurement';
import CoordinateVideoPage from './videos/coordinateVideo';
import BoundingBoxVideoPage from './videos/boundingboxVideo';
import FormationVideoPage from './videos/formationVideo';
import GeophoneVideoPage from './videos/geophoneVideo';
import HistogramVideoPage from './videos/histogramVideo';
import MeasurementVideoPage from './videos/measurementVideo';
import NavigationVideoPage from './videos/navigationVideo';
import ObjectInfoVideoPage from './videos/objectInfoVideo';
import PerforatorVideoPage from './videos/perforatorVideo';
import ProjectVideoPage from './videos/projectVideo';
import SeismicEventVideoPage from './videos/seismicEventVideo';
import WellboreVideoPage from './videos/wellboreVideo';

const DocTopic = () => {
  const { topic } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (topic === "project") {
    return <ProjectPage />
  }
  else if (topic === "coordinate") {
    return <CoordinatePage />
  }
  else if (topic === "wellbore") {
    return <WellborePage />
  }
  else if (topic === "boundingbox") {
    return <BoundingboxPage />
  }
  else if (topic === "geophone") {
    return <GeophonePage />
  }
  else if (topic === "perforator") {
    return <PerforatorPage />
  }
  else if (topic === "seismicEvent") {
    return <SeismicEventPage />
  }
  else if (topic === "formation") {
    return <FormationPage />
  }
  else if (topic === "histogram") {
    return <HistogramPage />
  }
  else if (topic === "navigation") {
    return <NavigationPage />
  }
  else if (topic === "objectInfo") {
    return <ObjectInfoPage />
  }
  else if (topic === "measurement") {
    return <MeasurementPage />
  } 
  else if (topic === "coordinateVideo") {
    return <CoordinateVideoPage />
  } 
  else if (topic === "boundingboxVideo") {
    return <BoundingBoxVideoPage />
  } 
  else if (topic === "formationVideo") {
    return <FormationVideoPage />
  } 
  else if (topic === "geophoneVideo") {
    return <GeophoneVideoPage />
  } 
  else if (topic === "histogramVideo") {
    return <HistogramVideoPage />
  } 
  else if (topic === "measurementVideo") {
    return <MeasurementVideoPage />
  }
  else if (topic === "navigationVideo") {
    return <NavigationVideoPage />
  }
  else if (topic === "objectInfoVideo") {
    return <ObjectInfoVideoPage />
  } 
  else if (topic === "perforatorVideo") {
    return <PerforatorVideoPage />
  } 
  else if (topic === "projectVideo") {
    return <ProjectVideoPage />
  } 
  else if (topic === "seismicEventVideo") {
    return <SeismicEventVideoPage />
  } 
  else if (topic === "wellboreVideo") {
    return <WellboreVideoPage />
  } 
  else {
    return null;
  }

}

export default DocTopic;
